import { ILimit, Limits } from "~/types/billing";
import { useAccount } from "./useAccount";
import { DISABLE_PAYMENTS, isFeatureEnabledOnPlan } from "~/helpers/plans";

const booleanFeatures = [
  Limits.ADS_WRITER,
  Limits.CHAT,
  Limits.PREMIUM_KEYWORDS,
  Limits.SAVE_DESCRIPTIONS,
];

export const usePlanFeature = () => {
  const { account } = useAccount();

  const isFeatureEnabled = (limitType: Limits) => {
    if (!account) return false;

    if (DISABLE_PAYMENTS) return true;

    const limits: ILimit | Record<any, any> =
      account?.active_subscription?.plan?.limits || {};

    if (account?.active_subscription?.paused_at) return false;

    if (limitType === Limits.PAID_PLAN) {
      return !!account?.active_subscription?.plan;
    }

    if (booleanFeatures.includes(limitType)) {
      return limits[limitType];
    }

    if (limitType === Limits.BLOG_GENERATED) {
      return account.blog_generation_count < limits[limitType];
    }

    switch (limitType as Limits) {
      case Limits.PAID_PLAN:
        return !!limits;
      case Limits.BLOG_GENERATED:
        return account.blog_generation_count < limits[limitType];
      case Limits.DESCRIPTIONS_GENERATED:
        return account.description_generation_count < limits[limitType];
      case Limits.GENERATION_COUNT_LIMIT:
        return true;
    }

    if (account?.active_subscription?.paused_at) return false;

    return isFeatureEnabledOnPlan(
      limitType,
      account?.active_subscription?.plan
    );
  };

  const isFeatureDisabled = (value: Limits) => !isFeatureEnabled(value);

  const isFeaturePaused = () => !!account?.active_subscription?.paused_at;

  return { isFeatureEnabled, isFeatureDisabled, isFeaturePaused };
};
